import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import ECommLoginServiceConfiguration from "./ECommLoginServiceConfiguration";

var _default = /*#__PURE__*/function (_ECommLoginServiceCon) {
  _inherits(_default, _ECommLoginServiceCon);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this);
    _this.estoreLocation = "https://store.tax.thomsonreuters.com/accounting";
    _this.siteLocation = "https://tax.thomsonreuters.com/site";

    _this.nameCookies.push("cs_thomsonreuters_com_astate_prod", "tax_thomsonreuters_com_astate_prod");

    return _this;
  }

  return _default;
}(ECommLoginServiceConfiguration);

export { _default as default };